import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.tooltip');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-tooltip',
template: templateSource || '',
    styles: [``],
})
export class ComponentTooltipComponent implements OnInit {
    @Input() msg: any;
    @Input() width: any;

    constructor(@Inject( Service)         public service: Service,    ) { }

    public async ngOnInit() {
        if(this.width==undefined){
            this.width = 15;
            this.service.render();
        }
    }
}

export default ComponentTooltipComponent;